import { useLocation } from "react-router-dom";

export function useRouteIsDocument() {
  const { pathname } = useLocation();
  // Exibe em /documentos e /documentos/:id
  return pathname.startsWith("/documentos/") && pathname !== "/documentos/";
}